import Loader from "../components/Loader";

const PageLoader = () => {
  return (
    <div className="fixed top-0 bg-[#D9D9D9]/90 h-screen w-screen z-50 flex items-center justify-center">
      <Loader />
    </div>
  );
};

export default PageLoader;
